import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  faCircleXmark,
  faTriangleExclamation,
  faCircleCheck,
  faCircleInfo,
  faXmark,
} from '@fortawesome/pro-solid-svg-icons';
import { MessagePopup, PopupInfoService } from '../../services/popup-info.service';

@Component({
  selector: 'app-popup-info',
  imports: [CommonModule, FontAwesomeModule],
  templateUrl: './popup-info.html',
  styleUrls: ['./popup-info.scss'],
})
export class PopupInfo {
  private readonly popupInfoService = inject(PopupInfoService);

  readonly messages$ = this.popupInfoService.messages$;

  // Font Awesome icons
  faCircleXmark = faCircleXmark;
  faTriangleExclamation = faTriangleExclamation;
  faCircleCheck = faCircleCheck;
  faCircleInfo = faCircleInfo;
  faXmark = faXmark;

  dismiss(id: string): void {
    this.popupInfoService.dismiss(id);
  }

  getIcon(type: MessagePopup['type']) {
    switch (type) {
      case 'error':
        return this.faCircleXmark;
      case 'warning':
        return this.faTriangleExclamation;
      case 'success':
        return this.faCircleCheck;
      case 'info':
        return this.faCircleInfo;
    }
  }

  getTitle(type: MessagePopup['type']): string {
    switch (type) {
      case 'error':
        return 'Error';
      case 'warning':
        return 'Advertencia';
      case 'success':
        return 'Completado';
      case 'info':
        return 'Información';
    }
  }
}
